'use client';

import { __awaiter, __generator, __assign } from '../../_virtual/_tslib.js';
import { getUTMTracking } from '../../ApplyJobsModal/helper.js';
import { ELanguage } from '../../Utils/constants.js';
import ModelError from '../model/index.js';
import { APPLY_MULTIPLE, MATCHING_JOB_URI } from './const.js';
import { createFormData } from './helper.js';

// https://staging-ms.vietnamworks.com/api-gateway/v1.0/job/apply-multiple
function applyJobs(baseUrl, accessToken, body, langCode, queryString) {
    var _a, _b, _c, _d;
    return __awaiter(this, void 0, void 0, function () {
        var formData, headerUtmsGAfirst, headderUtmsGA, query, response, json, applyJobRes, data, msg, error_1, data;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _e.trys.push([0, 3, , 4]);
                    formData = createFormData(body);
                    headerUtmsGAfirst = (_a = getUTMTracking()) === null || _a === void 0 ? void 0 : _a.headerUtmsGAfirst;
                    headderUtmsGA = (_b = getUTMTracking()) === null || _b === void 0 ? void 0 : _b.headderUtmsGA;
                    query = queryString ? "?".concat(queryString) : '';
                    return [4 /*yield*/, fetch("".concat(baseUrl, "/").concat(APPLY_MULTIPLE).concat(query), {
                            method: 'POST',
                            headers: __assign(__assign({ Authorization: "Bearer ".concat(accessToken), Accept: 'multipart/form-data', 'X-Requested-With': 'XMLHttpRequest', 'X-Tracking-Single-Apply': 'true', 'Accept-Language': langCode !== null && langCode !== void 0 ? langCode : ELanguage.VI }, headderUtmsGA), headerUtmsGAfirst),
                            body: formData
                        })];
                case 1:
                    response = _e.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    json = _e.sent();
                    if (json.data) {
                        applyJobRes = JSON.parse((_c = json.data) !== null && _c !== void 0 ? _c : '{}');
                        if (applyJobRes.code === 500) {
                            return [2 /*return*/, new ModelError({
                                    error: {
                                        message: applyJobRes.message,
                                        status: 500
                                    }
                                })];
                        }
                        if (applyJobRes.code === 'SY01') {
                            return [2 /*return*/, new ModelError({
                                    error: {
                                        message: applyJobRes.message,
                                        status: 500
                                    }
                                })];
                        }
                        return [2 /*return*/, applyJobRes];
                    }
                    if (!json.data) {
                        data = void 0;
                        if (json.error === 'bad request') {
                            data = {
                                data: {
                                    ERR_SYSTEM_BAD_REQUEST: 'ERR_SYSTEM_BAD_REQUEST'
                                },
                                error: {
                                    message: langCode === ELanguage.EN
                                        ? 'Sorry, there were some technical issues while processing your request. Please wait 5 minutes and try again or contact us.'
                                        : 'Đã có sự cố kỹ thuật trong khi xử lý yêu cầu của bạn. Vui lòng chờ 5 phút và thử lại hoặc liên hệ với chúng tôi để được hỗ trợ.',
                                    status: 400
                                }
                            };
                            return [2 /*return*/, new ModelError(data)];
                        }
                        if ((json === null || json === void 0 ? void 0 : json.success) === false && (json === null || json === void 0 ? void 0 : json.message)) {
                            msg = JSON.parse((_d = json === null || json === void 0 ? void 0 : json.message) !== null && _d !== void 0 ? _d : '{}');
                            data = {
                                data: {
                                    ERR_SYSTEM_BAD_REQUEST: 'ERR_SYSTEM_BAD_REQUEST'
                                },
                                error: {
                                    message: msg === null || msg === void 0 ? void 0 : msg.message,
                                    status: 400
                                }
                            };
                            return [2 /*return*/, new ModelError(data)];
                        }
                    }
                    return [2 /*return*/, null];
                case 3:
                    error_1 = _e.sent();
                    console.error(error_1);
                    if (error_1.message === 'Timeout' ||
                        error_1.message === 'Network request failed' ||
                        error_1.message === 'Failed to fetch') {
                        data = {
                            data: {
                                ERR_INTERNET_DISCONNECTED: 'ERR_INTERNET_DISCONNECTED'
                            },
                            error: {
                                message: langCode === ELanguage.EN
                                    ? 'No internet connection. Please check your internet connection and try again.'
                                    : 'Không có kết nối Internet. Vui lòng kiểm tra kết nối internet của bạn và thử lại.',
                                status: 503
                            }
                        };
                        return [2 /*return*/, new ModelError(data)];
                    }
                    return [2 /*return*/, new ModelError(error_1)];
                case 4: return [2 /*return*/];
            }
        });
    });
}
function matchingJobAPI(data) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var response, result, e_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, fetch("".concat(data.baseUrl, "/").concat(MATCHING_JOB_URI), {
                            method: 'POST',
                            headers: {
                                Authorization: "Bearer ".concat(data.accessToken),
                                'Accept-Language': (_a = data.langCode) !== null && _a !== void 0 ? _a : ELanguage.VI,
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify(data.body)
                        })];
                case 1:
                    response = _b.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    result = _b.sent();
                    return [2 /*return*/, result];
                case 3:
                    e_1 = _b.sent();
                    console.log('matchingJob: ', e_1);
                    return [2 /*return*/, null];
                case 4: return [2 /*return*/, null];
            }
        });
    });
}

export { applyJobs, matchingJobAPI };
//# sourceMappingURL=index.js.map
